import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { LanguageProvider } from "./context/LanguageContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import axios from "axios";

// Pages
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import RFQ from "./pages/RFQ";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import MarketAnalysis from "./pages/MarketAnalysis";
import Generators from "./pages/Generators";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Analytics tracker component
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view
    const trackPageView = async () => {
      try {
        await axios.post(`${BACKEND_URL}/api/analytics/pageview`, {
          page: location.pathname,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent
        });
      } catch (error) {
        // Silently fail analytics
        console.debug('Analytics tracking failed:', error);
      }
    };
    trackPageView();
  }, [location]);

  return null;
}

function AppContent() {
  return (
    <>
      <ScrollToTop />
      <AnalyticsTracker />
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/rfq" element={<RFQ />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/markets" element={<MarketAnalysis />} />
          <Route path="/generators" element={<Generators />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
